module.exports = __webpack_public_path__ + "img/certificate-1-3.ce3f3dba.jpg";